import { useEffect } from "react";

export const formatPrice = (price) => {
  const hasDecimals = price % 1 !== 0;
  return new Intl.NumberFormat("sv-SE", {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  })
    .format(price)
    .replace(/\u00A0/g, " ");
};

export const formatPriceWithCurrency = (price) => {
  if (price === null || price === undefined) {
    return "0";
  }

  return `${formatPrice(price)} kr`;
};

export const formatNumber = (number) => {
  const parsedNumber = parseFloat(number);
  if (!parsedNumber) {
    return "0";
  }

  return new Intl.NumberFormat("sv-SE").format(parsedNumber);
};

export const formatAge = (age) => {
  if (!age) {
    return 'Okänd ålder';
  }
  
  if (age > 100) {
    return '100+';
  }
  
  const decade = Math.floor(age / 10);
  const startDecade = decade !== 0 ? decade : '';
  const endDecade = decade + 1;
  
  return `${startDecade}0-${endDecade}0`;
};


const isBrowser = typeof window !== "undefined";

export const getStorageItem = (key) => {
  if (!isBrowser) {
    return null;
  }

  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

export const setStorageItem = (key, value) => {
  if (!isBrowser) {
    return;
  }

  try {
    window.localStorage.setItem(key, value);
  } catch (error) {}
};

export const KARTA_MAP_OPTIONS_STORAGE_KEY = "vb-minskog-map-settings";

export const getDefaultKartaMapOptions = (view) => ({
  showBorders: !view?.hideBorders,
  showSections: !view?.hideSections,
  showWarningSections: !view?.hideWarningSections,
  showMarkers: !view?.hideMarkers,
  sectionOpacity: 0.7,
});

export const readKartaMapOptionsFromStorage = (view) => {
  const raw = getStorageItem(KARTA_MAP_OPTIONS_STORAGE_KEY);
  if (!raw) {
    return getDefaultKartaMapOptions(view);
  }
  try {
    const parsed = JSON.parse(raw);
    const defaults = getDefaultKartaMapOptions(view);
    return {
      showBorders: typeof parsed.showBorders === "boolean" ? parsed.showBorders : defaults.showBorders,
      showMarkers: typeof parsed.showMarkers === "boolean" ? parsed.showMarkers : defaults.showMarkers,
      showSections: typeof parsed.showSections === "boolean" ? parsed.showSections : defaults.showSections,
      showWarningSections:
        typeof parsed.showWarningSections === "boolean" ? parsed.showWarningSections : defaults.showWarningSections,
      sectionOpacity: (() => {
        const raw = parsed.sectionOpacity;
        const number = typeof raw === "number" ? raw : typeof raw === "string" ? Number(raw) : NaN;
        return Number.isFinite(number) && number >= 0 && number <= 1 ? number : defaults.sectionOpacity;
      })(),
    };
  } catch {
    return getDefaultKartaMapOptions(view);
  }
};

export const persistKartaMapOptionsToStorage = (opts) => {
  const opacity = Number(opts.sectionOpacity);
  const sectionOpacity =
    Number.isFinite(opacity) && opacity >= 0 && opacity <= 1 ? opacity : getDefaultKartaMapOptions().sectionOpacity;
  setStorageItem(
    KARTA_MAP_OPTIONS_STORAGE_KEY,
    JSON.stringify({
      showBorders: opts.showBorders,
      showMarkers: opts.showMarkers,
      showSections: opts.showSections,
      showWarningSections: opts.showWarningSections,
      sectionOpacity,
    })
  );
};

export const useModalCloseOnEsc=(isOpen, handleClose) =>{
  useEffect(()=>{
    const handleEscape = (event) =>{
      if (event.key == "Escape" && isOpen){
        handleClose();
      }
    };
    if (isOpen){
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.addEventListener('keydown', handleEscape);
    };
  }, [isOpen, handleClose]);
};

export const formatDateSwedish = (date) => {
  return date.toLocaleDateString('sv-SE');
};
